module.exports = __webpack_public_path__ + "assets/img/search2x.ef15eb50.png";